export const PayrollRunType = {
  REGULAR: "regular",
  OFFCYCLE: "offCycle",
} as const;

export type PayrollRunType =
  (typeof PayrollRunType)[keyof typeof PayrollRunType];
